import {
  BgmAudioController,
  SoundAudioController,
} from '@dvb/common/src/classes';
import { useSettingStore } from '@school-manage/context/useSettingStore';
import { useEffect } from 'react';

/**
 * Since there have autoplay blocking policy, we need to do new the AudioContext after user interaction.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/Media/Autoplay_guide
 */
export function useAudioUnlock() {
  const { isMuteBgm, isMuteSound } = useSettingStore();

  useEffect(() => {
    /**
     * Reference howler.js
     *
     * @see https://github.com/goldfire/howler.js/blob/master/src/howler.core.js
     */
    const handleUserInteraction = () => {
      SoundAudioController.init(isMuteSound);
      BgmAudioController.init(isMuteBgm);

      window.removeEventListener('touchstart', handleUserInteraction);
      window.removeEventListener('touchend', handleUserInteraction);
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
    };

    window.addEventListener('touchstart', handleUserInteraction);
    window.addEventListener('touchend', handleUserInteraction);
    window.addEventListener('click', handleUserInteraction);
    window.addEventListener('keydown', handleUserInteraction);

    return () => {
      window.removeEventListener('touchstart', handleUserInteraction);
      window.removeEventListener('touchend', handleUserInteraction);
      window.removeEventListener('click', handleUserInteraction);
      window.removeEventListener('keydown', handleUserInteraction);
    };
  }, [isMuteBgm, isMuteSound]);
}
